import mainCaller from "./mainCaller";
import QueryString from 'qs';

export const createNotice = async (data, token) => {
  return await mainCaller(`admin/api/v1/notices`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}
export const updateNotice = async (data, id, token) => {
  return await mainCaller(`admin/api/v1/notices/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

export const getAllNotices = async (query, token) => {
  // const queryString = QueryString.stringify(query)
  return await mainCaller(`admin/api/v1/notices?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export const getNoticeById = async (id, token) => {
  return await mainCaller(`admin/api/v1/notices/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export const deleteNoticeById = async (id, token) => {
  return await mainCaller(`admin/api/v1/notices/${id}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
}

export const sendNoticeById = async (id, token) => {
  return await mainCaller(`admin/api/v1/notices/${id}/send`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });
}
